// extracted by mini-css-extract-plugin
export default {"wrapper":"MainSectionsFinalPage_wrapper__9zQXn"};